import { ApiClient } from '@olmt/shared'
import { API_BASE_URL } from './env'
import { useAuthStore } from '../stores/authStore'

/** The single HTTP client for the whole app (docs/CONTRACT.md §4). */
export const api = new ApiClient({ baseUrl: API_BASE_URL })

// Keep the bearer token in sync with the persisted session. `persist` rehydrates synchronously
// from localStorage, so the first read already has the token when one was stored.
api.setToken(useAuthStore.getState().token)
useAuthStore.subscribe((state, previous) => {
  if (state.token !== previous.token) api.setToken(state.token)
})
